"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var _classLib = require("class-lib");
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "className", "lineAtom"];
var Description = function Description(props) {
  var children = props.children,
    className = props.className,
    lineAtom = props.lineAtom,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded);
  var classes = (0, _classLib.mixClass)(className, "description");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restProps), {}, {
    ui: false,
    className: classes,
    children: children && children.map ? children.map(function (v, k) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], {
        atom: lineAtom,
        children: v
      }, k);
    }) : children
  }));
};
var _default = exports["default"] = Description;
module.exports = exports.default;